import { Select } from 'antd';
import { SelectValue } from "antd/lib/select";
import { observer } from 'mobx-react';
import React, { useEffect } from "react";
import ThemeFilterStore from '../../../stores/common/theme-filter';
import './style.css';

const { Option } = Select;

const ThemeFilter: React.FC<{ theme: ThemeFilterStore }> = ({ theme }) => {

    const handleChange = (value: SelectValue) => {
        theme.selectItem(value as string[]);
    }

    useEffect(() => { theme.loadDictionary(); }, [theme]);

    return (
        <Select
            mode={theme.multiple === true ? "multiple" : undefined}
            placeholder="тема"
            optionLabelProp="label"
            onChange={handleChange}
            value={theme.selectedItems}
            className="filter__item"
        >
            {theme.items?.map((i) => <Option key={i.id} value={i.id} label={i.name}>{i.name}</Option>)}
        </Select>
    );
};

export default observer(ThemeFilter);